module.exports = "/static/assets/5af49a475033b74b0ad20d5abd98ed7a.svg";